// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"163":"aptitude","895":"Privacidad"}[chunkId] + "." + {"163":"061e9002","895":"cd810089"}[chunkId] + ".css";
};